// Maps the exact English database `language` values to Dutch display labels.
// The DB value is kept English (so filtering keeps working); this is display-only.
const LANG_NL = {
  "Dutch": "Nederlands",
  "American English": "Amerikaans Engels",
  "British English": "Brits Engels",
  "Australian English": "Australisch Engels",
  "French": "Frans",
  "German": "Duits",
  "Spanish": "Spaans",
  "Latin American Spanish": "Latijns-Amerikaans Spaans",
  "Italian": "Italiaans",
  "Portuguese (Portugal)": "Portugees (Portugal)",
  "Portuguese (Brazil)": "Portugees (Brazilië)",
  "Belgian Flemish": "Belgisch Vlaams",
  "Greek": "Grieks",
  "Danish": "Deens",
  "Finnish": "Fins",
  "Norwegian": "Noors",
  "Swedish": "Zweeds",
  "Polish": "Pools",
  "Russian": "Russisch",
  "Romanian": "Roemeens",
  "Turkish": "Turks",
  "Arabic": "Arabisch",
  "Hebrew": "Hebreeuws",
  "Afrikaans": "Afrikaans",
  "Chinese": "Chinees",
  "Japanese": "Japans",
  "Korean": "Koreaans",
  "Hindi": "Hindi",
  "Vietnamese": "Vietnamees",
  "Multilingual (30+)": "Meertalig (30+)",
};

export const langNL = (value) => LANG_NL[value] || value || "";

// Maps the exact English database `country` values to Dutch display labels.
const COUNTRY_NL = {
  "Australia": "Australië",
  "Belgium": "België",
  "Brazil": "Brazilië",
  "China": "China",
  "Finland": "Finland",
  "France": "Frankrijk",
  "Germany": "Duitsland",
  "Greece": "Griekenland",
  "Italy": "Italië",
  "Japan": "Japan",
  "Latin America": "Latijns-Amerika",
  "Middle East": "Midden-Oosten",
  "Netherlands": "Nederland",
  "Norway": "Noorwegen",
  "Portugal": "Portugal",
  "Romania": "Roemenië",
  "Russia": "Rusland",
  "South Africa": "Zuid-Afrika",
  "Spain": "Spanje",
  "Sweden": "Zweden",
  "Turkey": "Turkije",
  "United Kingdom": "Verenigd Koninkrijk",
  "United States": "Verenigde Staten",
  "Vietnam": "Vietnam",
  "South Korea": "Zuid-Korea",
  "India": "India",
};

export const countryNL = (value) => COUNTRY_NL[value] || value || "";

// Maps English talent/demo tag values to Dutch display labels (display-only).
const TAG_NL = {
  "Natural": "Natuurlijk",
  "Commercial": "Commercieel",
  "Warm": "Warm",
  "Instant": "Direct",
  "AI": "AI",
  "Meertalig": "Meertalig",
};

export const tagNL = (value) => TAG_NL[value] || value || "";
